import { styled } from '$utils/theme'

interface Props {
  showBlock: boolean
  time?: number
}

export const FadeBlock = styled.div<Props>`
  ${p =>
    p.showBlock &&
    `
      opacity:1;
      transition:  opacity ${p.time ? p.time : 0.5}s;
  `}
  ${p =>
    !p.showBlock &&
    `
      opacity:0;
      transition: opacity ${p.time ? p.time : 0.5}s;
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/Fade/Fade.style.ts